<template>
  <div>
    <v-overlay :value="caricamento">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Avvisi login</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="addNew" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuovo avviso</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="setAvvisi" small v-bind="attrs" v-on="on" class="ml-5">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva avviso</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="$router.push('/home/notice')"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      :items="avvisi.filter((e) => e.validita == 1)"
      :headers="headers"
    >
      <template v-slot:[`item.modifica`]="{ item }">
        <v-btn small @click="modifica(item)">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </template>
      <!-- Colonna della data inizio -->
      <template v-slot:[`item.inizio`]="{ item }">
        {{ formatData(item.data_inizio) }}
      </template>

      <!-- Colonna della data fine -->
      <template v-slot:[`item.fine`]="{ item }">
        {{ formatData(item.data_fine) }}
      </template>
      <template v-slot:[`item.elimina`]="{ item, index }">
        <v-btn small @click="elimina(item, index)">
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="editDialog" width="75vw">
      <v-card>
        <v-toolbar class="indigo white--text" dense>
          <v-toolbar-title class="white--text">Modifica Avviso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-2" v-on="on" small @click="editDialog = false">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="editDialog = false" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="4">
              <v-text-field
                label="Data Inizio"
                type="datetime-local"
                v-model="editItem.data_inizio"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Data Fine"
                type="datetime-local"
                v-model="editItem.data_fine"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-textarea label="Testo" v-model="editItem.testo" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    SnackbarQV,
  },
  data() {
    return {
      caricamento: false,
      editDialog: false,
      editItem: {},
      utenti: [],
      avvisi: [],
      headers: [
        {
          text: "Modifica",
          value: "modifica",
        },
        {
          text: "Testo",
          value: "testo",
        },
        {
          text: "Data inizio",
          value: "data_inizio",
        },
        {
          text: "Data fine",
          value: "data_fine",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],
    };
  },
  methods: {
    formatData(arg) {
      return arg != null && arg != "" ? moment(arg).format("DD-MM-YYYY") : "";
    },
    async getAvvisi() {
      let request = {
        controller: "notice",
        method: "POST",
        richiesta: {
          action: "getavvisilogin",
          token: localStorage.user_token,
        },
      };
      this.caricamento = true;
      await this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.caricamento = false;
          this.avvisi = res.data.result;
        })
        .catch((err) => {
          this.caricamento = false;
          console.error(err);
        });
    },
    async setAvvisi() {
      this.caricamento = true;
      let request = {
        controller: "notice",
        method: "PUT",
        richiesta: {
          action: "saveavvisilogin",
          avviso: this.avvisi,
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api6", request).then((res) => {
        this.avvisi = res.data.result;
      });
      this.caricamento = false;
    },
    addNew() {
      this.avvisi.push({
        id_avvisi_login: -1,
        data_inizio: null,
        data_fine: null,
        testo: "",
        validita: 1,
      });
      this.modifica(this.avvisi[this.avvisi.length - 1]);
    },
    modifica(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    elimina(item, index) {
      if (item.id_notification == -1) {
        this.avvisi.splice(index, 1);
      } else {
        item.validita = 0;
      }
    },
  },
  async mounted() {
    await this.getAvvisi();
  },
};
</script>

<style></style>
